export default function() {
    return {
        reservations: [],
        page: 1,
        totalPages: 0,
        perPage: 15,
        searchParams: {
            'reservationStatus.id': null,
            roles: null,
            futureTrips: true,
            pastTrips: false
        },
        places: [],
        apiUrl: process.env.VUE_APP_API_URL,
        availableStatus: [],
        fields: [
            {
                key: 'id',
                label: 'ID Reserva'
            },
            {
                key: 'placeName',
                label: 'Destino'
            },
            {
                key: 'status',
                label: 'Status'
            },
            {
                key: 'date',
                label: 'Data do pedido'
            },
            {
                key: 'duration',
                label: 'Data da trip'
            },
            {
                key: 'changeStatus',
                label: 'Alterar status'
            },
            {
                key: 'actions',
                label: 'Ações'
            }
        ]
    }
}
